module.exports = __webpack_public_path__ + "img/circle-cross-12.22f0fb2a.svg";